/**
 * Date    : 2021/11/16
 * Author  : weiLin
 * Declare : index
 */

import React from 'react';
import { Spin } from '@/components/AntD';

import './index.scss';

export default function Loading(props) {

  const { theme, computedMatch, location, ...restProps } = props;

  return (
    <div className="Loading">
      {theme === THEME.default && <Spin {...restProps} />}
      {theme === THEME.rays && <div className="rays-loading">
        <div className="rays-loading-rect" />
      </div>}
    </div>
  );
}

const THEME = {
  default: 'default',
  rays: 'rays'
};

Loading.defaultProps = {
  theme: THEME.default
};

